import React, { createContext, useContext } from "react";

const InspectorMobileScenePeekContext = createContext(null);

export function InspectorMobileScenePeekProvider({ value, children }) {
  return (
    <InspectorMobileScenePeekContext.Provider value={value}>
      {children}
    </InspectorMobileScenePeekContext.Provider>
  );
}

/** @returns {{ compact: boolean } | null} */
export function useInspectorMobileScenePeek() {
  return useContext(InspectorMobileScenePeekContext);
}
